<template>
	<div class="about3">
		<div class="about3-c">
			<div class="about3-info">
				<div class="item">
					<div class="h">
						Qualification and Honor
					</div>
					<div class="s">
Safety production license, Class II general contracting of power engineering, Level Ⅲ testing (repair, testing), labor service, system certification, etc
					</div>
					<div class="imgs111">
						<div class="imgs-b" style="cursor: pointer;" v-for="(item, index) in list1" :key="index">
							<img class="h-img"  @click="handlePreview(item.barticleUrl)" style="object-fit: contain;" :src="item.barticleUrl" alt="">
							<img class="f-img" src="../../../../public/imgs/3881735286132_.pic.jpg" alt="">
						</div>
					</div>
				</div>
				<!-- <div class="item">
					<div class="h">
						authentication
					</div>
					<div class="s">
						ISO9001 Quality Management System, ISO14000 Environmental Management System, ISO45001 Occupational Health and Safety Management System, SA8000 Corporate Social Responsibility Management System
					</div>
					<div class="imgs111">
						<div class="imgs-b" v-for="(item, index) in list2" :key="index">
							<img class="h-img" style="object-fit: contain;" :src="item.barticleUrl" alt="" @click="previewImage(item.barticleUrl)">
							<img class="f-img" src="../../../../public/imgs/3881735286132_.pic.jpg" alt="">
						</div>
					</div>
				</div> -->
				<div class="item">
					<div class="h">
						honor
					</div>
					<div class="s">
						National level technology-based small and medium-sized enterprises, Zhejiang Province innovative small and medium-sized enterprises, Hangzhou Gongshu District Economic Contribution Excellent Award, Excellent Strategic Partner, AAA credit rating
					</div>
					<div class="imgs111">
						<div class="imgs-b" style="cursor: pointer;" v-for="(item, index) in list3" :key="index">
							<img class="h-img"  @click="handlePreview(item.barticleUrl)" style="object-fit: contain;" :src="item.barticleUrl" alt="">
							<img class="f-img" src="../../../../public/imgs/3881735286132_.pic.jpg" alt="">
						</div>
					</div>
				</div>
				<!-- <div class="item">
					<div class="h">
						Patent Software Works
					</div>
					<div class="s">
						1 invention patent, 2 computer software copyrights, and 9 utility model patents
					</div>
					<div class="imgs111">
						<div class="imgs-b" v-for="(item, index) in list4" :key="index">
							<img class="h-img"  style="object-fit: contain;" :src="item.barticleUrl" alt="" @click="previewImage(item.barticleUrl)">
							<img class="f-img" src="../../../../public/imgs/3881735286132_.pic.jpg" alt="">
						</div>
					</div>
				</div> -->
			</div>
		</div>
		
	    <div v-if="isShowImg" class="preImg newPreImg">
	    	<img :src="showImg" alt="" @click="closeViewer"/>
	    </div>
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			},
			list1: {
				type: Array,
				default: []
			},
			list2: {
				type: Array,
				default: []
			},
			list3: {
				type: Array,
				default: []
			},
			list4: {
				type: Array,
				default: []
			}
		},
		data() {
			return {
				isShowImg:false,
				showImg:"",
				tList:[
					{
						title:"资质",
						sec:"电力工程施工总承包贰级承装类、承修类、承试类四级、劳务分包不分等级"
					},{
						title:"认证",
						sec:"ISO9001质量管理体系、ISO14000环境管理体系、ISO45001职业健康安全管理体系、SA8000企业社会责任管理体系"
					},{
						title:"荣誉",
						sec:"国家级科技型中小企业、浙江省创新型中小企业、杭州拱墅区经济贡献优秀奖、优秀战略合作商、AAA信用等级"
					},{
						title:"专利软著",
						sec:"发明专利1项、计算机软著2项、实用型新型专利9项"
					}
				],
               
			}
		},
		created() {

		},
		methods: {
			handlePreview(url) {
				this.showImg = url
			      this.isShowImg = true
			    },
			    // 关闭查看器
			    closeViewer() {
			      this.isShowImg = false
			    },
			previewImage(url){
				this.$emit("previewImage", url)
			}

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}

	.about3 {
		
		.preImg {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: rgba(0, 0, 0, 0.5);
			z-index: 9999;
			img {
				width: 50%;
				height: 80%;
				object-fit: contain;
			}
		}

		.about3-c {
			background-color: white;
			display: flex;
			justify-content: center;
			.about3-info {
				// min-width: 1200px;
				.item {
					text-align: center;
					.h {
						color: #332C2B;
					}
					.s {
						
						color: #999999;
					}
					.imgs111 {
						align-items: center;
						flex-wrap: wrap;
						.imgs-b {
							flex-direction: column;
							justify-content: center;
							align-items: center;
							
						}
					}
				}		
			}
		}	
	}
	
	
	@media screen and (min-width: 1200px) {
		.about3 {
			width: 100%;
		
			.about3-c {
				width: 100%;
				display: flex;
				padding: 120px 0 120px;
				.about3-info {
					width: 1200px;
					.item {
						margin-bottom: 32px;
						.h {
							font-size: 32px;
						}
						.s {
							margin-top: 16px;
							font-size: 16px;
						}
						.imgs111 {
							margin-top: 56px;
							display: flex;
							justify-content: flex-start;
							
							.imgs-b {
								width: calc(33.33% - 15px);
								height: 328px;
								display: flex;
								margin-right: 15px;
								.h-img {
									width: 90%;
									height: 220px;
								}
								.f-img {
									width: 100%;
									height: 108px;
								}
							}
						}
					}		
				}
			}	
		}
	
	}
	@media screen and (max-width: 1200px) {
		.about3 {
			width: 100%;
		
			.about3-c {
				width: 100%;
				display: flex;
				padding: 80px 20px;
				.about3-info {
					width: 100%;
					.item {
						margin-bottom: 24px;
						.h {
							font-size: 24px;
						}
						.s {
							margin-top: 12px;
							font-size: 15px;
						}
						.imgs111 {
							margin-top: 40px;
							display: flex;
							flex-wrap: wrap;
							justify-content: flex-start;
							.imgs-b {
								width: calc(25% - 15px);
								height: 240px;
								display: flex;
								margin-right: 15px;
								.h-img {
									width: 90%;
									height: 180px;
								}
								.f-img {
									width: 100%;
									height: 60px;
								}
							}
						}
					}		
				}
			}	
		}
	
	}
	@media screen and (max-width: 880px) {
		.preImg{
			&.newPreImg{
				img{
					width:98%;
				}
			}
		}
		.about3 {
			width: 100%;
		
			.about3-c {
				width: 100%;
				display: flex;
				padding: 40px 12px;
				.about3-info {
					width: 100%;
					.item {
						margin-bottom: 14px;
						.h {
							font-size: 18px;
						}
						.s {
							margin-top: 12px;
							font-size: 14px;
						}
						.imgs111 {
							margin-top: 20px;
							display: flex;
							flex-wrap: wrap;
							justify-content: space-between;
							
						
							.imgs-b {
								width: calc(50% - 10px);
								height: 180px;
								display: flex;
								margin-right: 0px;
								margin-bottom: 12px;
								.h-img {
									width: 90%;
									height: 140px;
								}
								.f-img {
									width: 100%;
									height: 40px;
								}
							}
						}
					}		
				}
			}	
		}
	
	}
</style>
